import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=814ece42&scoped=true&"
import script from "./PricingPage.vue?vue&type=script&lang=js&"
export * from "./PricingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814ece42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/gadzoom/gadzoom-marketing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('814ece42')) {
      api.createRecord('814ece42', component.options)
    } else {
      api.reload('814ece42', component.options)
    }
    module.hot.accept("./PricingPage.vue?vue&type=template&id=814ece42&scoped=true&", function () {
      api.rerender('814ece42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pricing/PricingPage.vue"
export default component.exports